module.exports = __webpack_public_path__ + "img/ptr.74ceefe6.jpg";